// extracted by mini-css-extract-plugin
module.exports = {"errorPage":"ErrorPage_errorPage__19I5i","container":"ErrorPage_container__Vjt8J","title":"ErrorPage_title__xSb4y","subTitle":"ErrorPage_subTitle__SvVvZ"};